<div>

  <ng-container *ngIf="loadingPublicReview===true">
    <app-preloader [loaderText]="'Loading Public Review List'" class="w-100 position-fixed preloader-backdrop"></app-preloader>
  </ng-container>

  <ng-container *ngIf="loadingPublicReview===false">
    <div class="my-3 px-3" *ngIf="publicReviewPermission===true">
      <button type="button" class="btn btn-primary btn-sm" id="crtpublicreviewBtn" [disabled]="preventEdit" (click)="onPublicReviewModalOpen()">Create Public Review</button>
    </div>

    <h2 class="font-5x font-bold px-3">Public Review History</h2>
    <app-data-table class="w-100" [showMenu]="true" [tableCategory]="'Public Review'" [columnList]="listOfColumn"
      [dataSet]="publicReviewList" [optionList]="optionList" (clickedOption)="onOptionClicked($event)"></app-data-table>

  </ng-container>
</div>
